import React from 'react';

import { applicationTitles } from '../../localization/en-us/applicationTitles';

import classes from './Title.module.css';

const ServiceManagementTitle = props => {
    return (
        <div className={classes.TitleBox}>
            <img src="/assets/images/serviceManualIconColor.svg" alt="Service Management" />
            <p>{applicationTitles.serviceManagement}</p>
        </div>
    );
};

export default ServiceManagementTitle;
